import React from 'react';
import PredictionCalculatorSC from './prediction-calculator.styled';
import { BodyText, SmallText } from '../typography';
import { FormattedMessage, useIntl } from 'react-intl';
import Button from '../ui/button';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ActionCreators from '../../redux/action';
import { Formik } from 'formik';
import OptionsToggle from './components/options-toggle';
import OptionsSwitcher from './components/options-switcher';

const init = {
  initialDeposit: 1001,
  monthlyDeposit: 50,
  numberOfYears: 5,
  interestRate: 6.5,
};

const PredictionCalculator = ({ getEstimatedEarningsGraphData }) => {
  const { formatMessage: fm } = useIntl();

  React.useEffect(() => {
    getEstimatedEarningsGraphData({
      initial_deposit: init.initialDeposit,
      monthly_deposit: init.monthlyDeposit,
      years: init.numberOfYears,
    });
  }, [getEstimatedEarningsGraphData]);

  return (
    <PredictionCalculatorSC>
      <Formik
        initialValues={init}
        validator={() => ({})}
        onSubmit={(values) => {
          getEstimatedEarningsGraphData({
            initial_deposit: values.initialDeposit,
            monthly_deposit: values.monthlyDeposit,
            years: values.numberOfYears,
          });
        }}
      >
        {({ values, handleChange, handleSubmit, setFieldValue }) => {
          return (
            <form onSubmit={handleSubmit}>
              <div className="mid-wrap--card mb-small">
                <div className="mid-wrap--card__top">
                  <BodyText className="grey bolder ">
                    <FormattedMessage
                      id="investor_prediction_calculator_initial_deposit"
                      defaultMessage="investor_prediction_calculator_initial_deposit"
                    />
                  </BodyText>
                  {/*  <HintSC>?</HintSC> */}
                </div>
                <div className="mid-wrap--card__bottom">
                  <div className="wrap">
                    <label htmlFor="initialDeposit" className="input-label">
                      €
                    </label>
                    <input
                      id="initialDeposit"
                      name="initialDeposit"
                      className="invest-amount-input"
                      type="text"
                      placeholder="1 000,00"
                      value={values.initialDeposit || ''}
                      onChange={(e) => {
                        const value = e.target.value;
                        let interestRate = 5;
                        if (value > 1000) {
                          interestRate = 6.5;
                        }
                        if (value > 5000) {
                          interestRate = 8;
                        }
                        setFieldValue('initialDeposit', e.target.value);
                        setFieldValue('interestRate', interestRate);
                      }}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>
              <div className="toggle-wrapper">
                <SmallText className="grey">
                  <FormattedMessage
                    id="investor_prediction_calculator_interest_rate"
                    defaultMessage="investor_prediction_calculator_interest_rate"
                  />
                </SmallText>
                <OptionsToggle
                  value={values.interestRate}
                  onChange={(opt) => {
                    switch (opt.value) {
                      case 5:
                        setFieldValue('initialDeposit', 500);
                        break;
                      case 6.5:
                        setFieldValue('initialDeposit', 1001);
                        break;
                      case 8:
                        setFieldValue('initialDeposit', 5001);
                        break;
                      default:
                        break;
                    }
                    setFieldValue('interestRate', opt.value);
                  }}
                  options={[
                    {
                      value: 5,
                      text: '5 %',
                      subText: fm({ id: 'investor_prediction_calculator_interest_rate_low' }),
                    },
                    {
                      value: 6.5,
                      text: '6,5 %',
                      subText: fm({ id: 'investor_prediction_calculator_interest_rate_medium' }),
                    },
                    {
                      value: 8,
                      text: '8 %',
                      subText: fm({ id: 'investor_prediction_calculator_interest_rate_high' }),
                    },
                  ]}
                />
              </div>
              <div className="mid-wrap--card mb-0">
                <div className="mid-wrap--card__top">
                  <BodyText className="grey bolder ">
                    <FormattedMessage
                      id="investor_prediction_calculator_monthly_deposit"
                      defaultMessage="investor_prediction_calculator_monthly_deposit"
                    />
                  </BodyText>
                  {/*  <HintSC>?</HintSC> */}
                </div>
                <div className="mid-wrap--card__bottom">
                  <div className="wrap">
                    <label htmlFor="monthlyDeposit" className="input-label">
                      €
                    </label>
                    <input
                      name="monthlyDeposit"
                      id="monthlyDeposit"
                      className="invest-amount-input"
                      type="text"
                      placeholder="1 000,00"
                      value={values.monthlyDeposit || ''}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
              <div className="mid-wrap--card">
                <div className="years-switch">
                  <BodyText className="grey bolder years-switch--label">
                    <FormattedMessage
                      id="investor_prediction_calculator_years"
                      defaultMessage="investor_prediction_calculator_years"
                    />
                  </BodyText>
                  <div className="years-switch__group">
                    <OptionsSwitcher
                      value={values.numberOfYears}
                      onChange={(opt) => setFieldValue('numberOfYears', opt)}
                      options={[1, 5, 10, 15, 20]}
                    />
                  </div>
                </div>
              </div>
              <div className="submit-wrap">
                <Button type="PRIMARY" size="BIG">
                  <FormattedMessage
                    id="investor_prediction_calculator_submit"
                    defaultMessage="investor_prediction_calculator_submit"
                  />
                </Button>
              </div>
            </form>
          );
        }}
      </Formik>
    </PredictionCalculatorSC>
  );
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getEstimatedEarningsGraphData: ActionCreators.getEstimatedEarningsGraphData,
    },
    dispatch
  );
export default connect(undefined, mapDispatchToProps)(PredictionCalculator);
